// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Right pane layout */
.right-pane {
  padding: 5px;
  background: #0f172a;
  height: 100vh;
}

/* Wrapper */
.quote-wrapper {
  max-width: 500px;
  margin: auto;
}

/* Title */
.quote-title {
  color: white;
  margin-bottom: 15px;
}

/* Card */
.quote-card {
  background: white;
  padding: 5px;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.3);
  transition: 0.3s;
}

.quote-card:hover {
  transform: translateY(-5px);
}

/* Text */
.quote-text {
  font-size: 18px;
  color: black;
  line-height: 1.5;
}

/* Button */
.quote-btn {
    float:right;
  margin-top: -20px; 
  /* padding: 8px 14px; */
  border: none;
  background: #2563eb;
  color: white;
  border-radius: 8px;
  cursor: pointer;
}

.quote-btn:hover {
  background: #1d4ed8;
}`, "",{"version":3,"sources":["webpack://./src/components/quotation/Quotations.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA,UAAU;AACV;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA,WAAW;AACX;IACI,WAAW;EACb,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Right pane layout */\n.right-pane {\n  padding: 5px;\n  background: #0f172a;\n  height: 100vh;\n}\n\n/* Wrapper */\n.quote-wrapper {\n  max-width: 500px;\n  margin: auto;\n}\n\n/* Title */\n.quote-title {\n  color: white;\n  margin-bottom: 15px;\n}\n\n/* Card */\n.quote-card {\n  background: white;\n  padding: 5px;\n  border-radius: 16px;\n  box-shadow: 0 8px 30px rgba(0,0,0,0.3);\n  transition: 0.3s;\n}\n\n.quote-card:hover {\n  transform: translateY(-5px);\n}\n\n/* Text */\n.quote-text {\n  font-size: 18px;\n  color: black;\n  line-height: 1.5;\n}\n\n/* Button */\n.quote-btn {\n    float:right;\n  margin-top: -20px; \n  /* padding: 8px 14px; */\n  border: none;\n  background: #2563eb;\n  color: white;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.quote-btn:hover {\n  background: #1d4ed8;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
